import { mapState } from 'vuex';
import f from "@/application/shared/functions.js";

import storyPreview from "@/components/modules/stories/preview/index.vue";
import story from "@/components/modules/stories/story/index.vue";

import intro from "./intro/index.vue";
import last from "./last/index.vue";

export default {
    name: 'courseevent',
    props: {
        event : Object,
        height : Number,
        focused : Boolean,
        status : Object
    },

    data : function(){

        return {
            loading : false,
            wasfocused : false,
            initedStory : false
        }

    },

    components : {
        storyPreview,
        story,
        intro,
        last
    },

    created(){
    },

    watch: {
        focused : {
            immediate : true,
            handler : function(){
                if(this.focused){
                    setTimeout(() => {
                        if (this.focused){
                            this.wasfocused = true
                        }
                    }, 3000)

                    if (this.$refs.message)
                        this.$refs.message.scrollTop = 0
                }

                else{
                    if (this.$refs['story'] && this.$refs['story'].pause){

                        this.$refs['story'].pause()
                    }
                }


            }
        }
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        vmessage : function(){

            if(this.event.type == 'message') {
                if(this.event.data.type == 'message' || this.event.data.type == 'system') {
                    return f.convertNewLinesToBr(f.superXSS(this.event.data.text))
                }
            }

            return ''
        },

        you : function(state){

            var me = this.core.user.info.userinfo.id

            return this.event.creator == me
        },
        
        viewRestriction : function(){

            if(!this.status){
                return {
                    caption : 'snippity.course.restrictionUndefined'
                }
            }

            if(this.status.value == 'finished') return null
            if(this.status.value == 'current'){

                if(!this.status.waituntil){
                    return null
                }
                else{
                    return {
                        caption : 'snippity.course.restrictionUntil',
                        until : this.status.waituntil
                    }
                } 
            }

            return {
                caption : 'snippity.course.restriction'
            }
        }
    }),

    methods : {
        click : function(){
            this.$emit('click', this.event)
        },

        copymessage : function(){
            f.copyTextToClipboard(this.event.data.message)

            this.core.sitemessage(this.$t('labels.copied'))
        },

        copycode : function(){
            f.copyTextToClipboard(f.convertNewLinesToBr(this.event.data.html))

            this.core.sitemessage(this.$t('labels.copied'))

        },

        gotostory : function(){

            this.initedStory = true
            
        },

        clickMetaButton : function(){
            if (this.event.data.button.url){
                this.$router.push(this.event.data.button.url)
                return
            }
        },

        cevent : function(data){
            this.$emit('cevent', data)
        },

        end : function(data = {}){
            this.$emit('cevent', {
                name : 'end',
                value : this.event,
                data : data
            })
        }, 
    },
}